import React, { useEffect, useState } from 'react';
import {Table, Drawer} from 'antd';

import AddSetupDetails from 'modules/system_setup/add_system_setup_values/addSetupDetails';

const columns = [
    {
        title: "MESSAGE CODE",
        dataIndex: "message_code",
        key: "message_code",
        width: "15%"
    },
    {
        title: "MESSAGE DISPLAY",
        dataIndex: "message_display",
        key: "message_display",
        width: "25%"
    },
    {
        title: "DESCTIPTION",
        dataIndex: "message_description",
        key: "message_description",
        width: "45%"
    },
    {
        title: "DATE CREATED",
        dataIndex: "formatted_date",
        key: "formatted_date",
        width: "15%"
    },
];

function SearchMessagePromptsTable(props) {
    const { data, pageSize } = props;
    const [tableData, setTableData] = useState([]);
    const [tableValues, setTableValues] = useState(data);
    
    const [open, setOpen] = useState(false);
    const showDrawer = () => { setOpen(true); };

    const onClose = () => { 
        setOpen(false); 
        // setTableData([]);
    };

    useEffect(()=> {
        setTableValues(data);
    }, [data])

    function setData(values) {
        setTableValues(values);
    }

    function refreshTblData(values) {
        console.log('check messages refresh', values)
    }

    function updateDrawer(e) {
        setTableData(e)
        showDrawer();
    }

    function drawerClose(value) {
        setOpen(value);
    }

    return(
        <div>
            <Table
                style={ {textTransform: "uppercase"} }
                dataSource = {tableValues}
                columns={columns}
                bordered
                pagination={{ defaultPageSize: 5 }}
                onRow={(record) => {
                    return {
                        onDoubleClick: (e) => {updateDrawer(record)}
                    };
                }}
            />
            <Drawer title={"UPDATE " + props.setupValue} placement="right" onClose={onClose}
                width="30%"
                visible={open}
            >
                <AddSetupDetails 
                    setupDet={props.setupValue} 
                    drawerClose={ drawerClose }
                    refreshTblData={ refreshTblData }
                    tableData={ tableData }
                    setData={ setData }
                />
            </Drawer>
        </div>
    )
}

export default SearchMessagePromptsTable;